import Counter from 'LuxKit/Counter'
import InputText from 'LuxKit/Typography/InputText'
import Group from 'components/utils/Group'
import React from 'react'

type GroupProps = React.ComponentProps<typeof Group>

interface Props extends React.ComponentProps<typeof Counter> {
  label?: string
  subLabel?: string
  direction?: 'horizontal' | 'vertical'
  tabletDirection?: 'horizontal' | 'vertical'
  horizontalAlign?: GroupProps['horizontalAlign']
  tabletHorizontalAlign?: GroupProps['tabletHorizontalAlign']
  verticalAlign?: GroupProps['verticalAlign']
  tabletVerticalAlign?: GroupProps['tabletVerticalAlign']
}

function CounterInput(props: Props) {
  const {
    label,
    className,
    subLabel,
    horizontalAlign,
    tabletHorizontalAlign,
    verticalAlign,
    tabletVerticalAlign,
    ...counterProps
  } = props

  const direction = props.direction ?? 'horizontal'
  const tabletDirection = props.tabletDirection ?? props.direction ?? 'vertical'

  return <Group
    as="label"
    className={className}
    direction={direction}
    verticalAlign={verticalAlign ?? (direction === 'vertical' ? undefined : 'center')}
    horizontalAlign={horizontalAlign ?? (direction === 'vertical' ? undefined : 'space-between')}
    gap={12}
    tabletDirection={tabletDirection}
    tabletVerticalAlign={tabletVerticalAlign ?? (tabletDirection === 'vertical' ? undefined : 'center')}
    tabletHorizontalAlign={tabletHorizontalAlign ?? (tabletDirection === 'vertical' ? 'start' : 'space-between')}
  >
    {(label || subLabel) && <div>
      {label && <InputText variant="label">{label}</InputText>}
      {subLabel && <InputText variant="sub-label">{subLabel}</InputText>}
    </div>}
    <Counter {...counterProps} />
  </Group>
}

export default CounterInput
